<template>
  <div class="page-selector" style="display: flex; align-items: center; gap: 12px;">
    <span style="font-weight: 600; font-size: 15px; color: #333;">페이지 선택</span>
    <a-select
      :value="currentPage"
      style="width: 160px;"
      @change="handlePageChange"
    >
      <a-select-option value="main">메인 페이지</a-select-option>
      <a-select-option value="pricing">가격안내</a-select-option>
      <a-select-option value="services">서비스소개</a-select-option>
      <a-select-option value="downloads">다운로드</a-select-option>
    </a-select>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { Modal } from 'ant-design-vue';

export default {
  name: 'PageSelector',

  computed: {
    ...mapGetters('homepageEditor', ['isDirty', 'currentPageData']),

    // 현재 선택된 페이지 키
    currentPage() {
      return this.$store.state.homepageEditor.currentPage;
    },
  },

  methods: {
    ...mapMutations('homepageEditor', ['SET_CURRENT_PAGE']),

    // 페이지 변경 핸들러 (dirty 상태 확인 후 변경)
    handlePageChange(newPage) {
      if (this.isDirty) {
        // 저장되지 않은 변경사항이 있을 경우 확인 모달 표시
        Modal.confirm({
          title: '페이지 변경',
          content: '저장되지 않은 변경사항이 있습니다. 페이지를 이동하면 변경사항이 사라집니다. 계속하시겠습니까?',
          okText: '이동',
          cancelText: '취소',
          onOk: () => {
            this.changePage(newPage);
          },
        });
      } else {
        this.changePage(newPage);
      }
    },

    // 실제 페이지 변경 및 데이터 로드
    changePage(page) {
      this.SET_CURRENT_PAGE(page);
      this.$store.dispatch('homepageEditor/loadPageData', page).catch((err) => {
        console.error('[PageSelector] 페이지 데이터 로드 실패:', err);
      });
    },
  },
};
</script>
